<div class="row">
    <div class="col-12">
        <ngx-skeleton-loader
            [theme]="{ width: '50px', height: '50px', 'background-color': backgroundColor() }"
        ></ngx-skeleton-loader>
    </div>
</div>
